import React from 'react';
import { Typography, Space } from 'antd';

const { Text, Link } = Typography;

export const AppFooter: React.FC = () => {
  return (
    <footer
      style={{
        padding: '16px 24px',
        backgroundColor: '#f5f5f5',
        borderTop: '1px solid #e8e8e8',
        textAlign: 'center',
      }}
    >
      <Space direction="vertical" size={4}>
        <Text type="secondary" style={{ fontSize: '13px' }}>
          Based on "Take That Hill!" by{' '}
          <Link href="https://www.kcl.ac.uk/people/professor-philip-sabin" target="_blank" rel="noopener noreferrer">
            Prof. Philip Sabin
          </Link>
          {' '}and{' '}
          <Link href="https://www.fightclubinternational.org/de/take-that-hill-old" target="_blank" rel="noopener noreferrer">
            Fight Club International
          </Link>
        </Text>
        <Text type="secondary" style={{ fontSize: '13px' }}>
          Digital adaptation developed with permission. Created by{' '}
          <Link href="https://aka.ms/taras" target="_blank" rel="noopener noreferrer">
            Taras Kloba
          </Link>
          .
        </Text>
      </Space>
    </footer>
  );
};

export default AppFooter;
